var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bus_",
    "data-name": "bus ",
    transform: "translate(-510 -234)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 52,
    height: 52,
    rx: 12,
    transform: "translate(510 234)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bus_condition",
    "data-name": "bus condition",
    transform: "translate(122 -104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 36,
    height: 36,
    transform: "translate(396 346)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338",
    transform: "translate(133.831 21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16024",
    "data-name": "Group 16024",
    transform: "translate(-4.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    d: "M1.3,1.3V10H16.087V1.3H1.3M0,0H17.391V11.3H0Z",
    transform: "translate(275.386 335.479)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_37",
    "data-name": "Line 37",
    d: "M.554,8.7H-.75V0h1.3Z",
    transform: "translate(284.136 336.78)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16023",
    "data-name": "Group 16023"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_40",
    "data-name": "Line 40",
    d: "M.554,2.609H-.75V0h1.3Z",
    transform: "translate(278.093 351.13)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_41",
    "data-name": "Line 41",
    d: "M.554,2.609H-.75V0h1.3Z",
    transform: "translate(286.789 351.13)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_42",
    "data-name": "Line 42",
    d: "M.554,2.609H-.75V0h1.3Z",
    transform: "translate(281.571 351.13)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_43",
    "data-name": "Line 43",
    d: "M.554,2.609H-.75V0h1.3Z",
    transform: "translate(290.267 351.13)",
    fill: "#006"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_50-2",
    "data-name": "Rectangle 50",
    d: "M2.609,1.3a1.306,1.306,0,0,0-1.3,1.3V17.391a1.306,1.306,0,0,0,1.3,1.3H14.783a1.306,1.306,0,0,0,1.3-1.3V2.609a1.306,1.306,0,0,0-1.3-1.3H2.609m0-1.3H14.783a2.609,2.609,0,0,1,2.609,2.609V17.391A2.609,2.609,0,0,1,14.783,20H2.609A2.609,2.609,0,0,1,0,17.391V2.609A2.609,2.609,0,0,1,2.609,0Z",
    transform: "translate(275.386 332)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_38",
    "data-name": "Line 38",
    d: "M5.12.554H-.1A.652.652,0,0,1-.75-.1.652.652,0,0,1-.1-.75H5.12A.652.652,0,0,1,5.772-.1.652.652,0,0,1,5.12.554Z",
    transform: "translate(281.571 348.62)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_23_-_Outline",
    "data-name": "Ellipse 23 - Outline",
    d: "M.87,0A.87.87,0,1,1,0,.87.87.87,0,0,1,.87,0Z",
    transform: "translate(278.43 347.652)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_24_-_Outline",
    "data-name": "Ellipse 24 - Outline",
    d: "M.87,0A.87.87,0,1,1,0,.87.87.87,0,0,1,.87,0Z",
    transform: "translate(287.995 347.652)",
    fill: "#19bc9c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line_44",
    "data-name": "Line 44",
    d: "M28.6.554H-.1A.652.652,0,0,1-.75-.1.652.652,0,0,1-.1-.75H28.6A.652.652,0,0,1,29.25-.1.652.652,0,0,1,28.6.554Z",
    transform: "translate(265.919 353.837)",
    fill: "#19bc9c"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.dc86d7de596c34c23ad03943c90b1f78.svg";
export { ForwardRef as ReactComponent };